import { render, staticRenderFns } from "./ModalContentCgu.vue?vue&type=template&id=eeca0980&scoped=true&"
import script from "./ModalContentCgu.vue?vue&type=script&lang=js&"
export * from "./ModalContentCgu.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentCgu.vue?vue&type=style&index=0&id=eeca0980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeca0980",
  null
  
)

export default component.exports